import React, { Component, useState ,useEffect} from 'react';
import DatePicker, { setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select'

import Axios from 'axios';

import Dtable from "./Dtable";
import GraphsCard from "./GraphsCard";
import Pie from "../Shared/Pie";
import Bar from "../Shared/Bar";

import Cash from "./Cash";
import Equity from "./Equity";
import PvtInvestment from "./PvtInvestment";
import Bond from "./Bond";
import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";

import Loader from "../../utils/Loader";



function Index() {

    const userInfo = JSON.parse(localStorage.getItem("userInfo"))

    const [currencies, setCurrencies] = useState([]);

    const [dateType,setDateType] = useState("TRADEDATE");

    const [selectedCurrency, setSelectedCurrency] = useState(userInfo?.baseCurrency?.id);
    const [selectedCurrencylbl, setSelectedCurrencylbl] = useState(userInfo?.baseCurrency?.shortName);

    const [startDate, setStartDate] = useState(new Date());
    const [mode, setMode] = useState("full");
    const [showMainGraphs, setShowMainGraphs] = useState(true);
    const [portfolios, setPortfolios] = useState([]);
    const [selectedPortfolio, setSelectedPortfolio] = useState(null);
   

    const [sigmaData,setSigmaData] = useState([]);
    const [percentData,setPercentData] = useState([]);

    const [percentColspan,setPercentColspan] = useState(1);
    const [sigmaColspan,setSigmaColspan] = useState(1);
    const [defaultPortfolio, setDefaultPortfolio] = useState([]);
 


    const [fullData,setFullData] = useState([]);
    const [assetAllocationData,setAssetAllocationData] = useState([]);
    const [currencyAllocationData,setCurrencyAllocationData] = useState([]);
    const [valuationData,setValuationData] = useState([]);
    const [valuationcategories,setValuationcategories] = useState([]);

    const [loading, setsLoading] = useState(false);
    const [payload, setPayload] = useState({});
    const [assetClass, setAssetClass] = useState(null);
    const [assetClasses, setAssetClasses] = useState(null);
    const [assetClassName, setAssetClassName] = useState(null);

   

    localStorage.setItem("pageName","Dashboard");

    useEffect(() => {
        fetchCurrencies()
        fetchPortfolios();
        
        if(!Helpers.isEmpty(userInfo)){
            setSelectedCurrency(userInfo?.baseCurrency?.id);
            setSelectedCurrencylbl(userInfo?.baseCurrency?.shortName)
        }
    }, [])

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
        return (
            <div className="input-group  customDatePicker">
            <input type="text" className="form-control datefield no-border-radius" aria-label="date" aria-describedby="date" defaultValue={value} onClick={onClick}/>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2"><i className="fa fa-calendar"></i></span>
            </div>
          </div>
        );
    });

    const onChangePortfolio = (e)=>{
        setSelectedPortfolio(e);
    }

    const fetchCurrencies = ()=>{
        setsLoading(true)
        Axios.get(Config.api("api/currencies"))
            .then( (response) => {
                 var data =  response.data;
                 setCurrencies(data)
                 setsLoading(false)
            })
            .catch((err) => {
                setsLoading(false)
            });
    }


    const fetchPortfolios = ()=>{
        setsLoading(true)
        Axios.get(Config.api("api/portfolios/publish-list"))
            .then( (response) => {
                 var data =  response.data;
                 var formatedPortfolio = data?.rows?.map((x)=>({"value":x.portfolioId,"label":x.portfolioName}))
                 var defaultPortfolioslcl = data?.rows?.filter((x)=>x.defaultPortfolio).map((x)=>({"value":x.portfolioId,"label":x.portfolioName,"dateType":x.dateType}));
                 setPortfolios(formatedPortfolio);
                 setStartDate(new Date(data?.asOfDate));
                 setSelectedPortfolio(defaultPortfolioslcl);
                 if(!Helpers.isEmpty(defaultPortfolioslcl)){
                    getDataForDefault(defaultPortfolioslcl,data?.asOfDate)
                 }else{
                    getDataForDefault([],data?.asOfDate)
                 }
                 setsLoading(false)
            })
            .catch((err) => {
                setsLoading(false)

            });
    }


 
    const toggleMode = (e)=>{
        let localMode = e.currentTarget.dataset.name;
        setMode(localMode);
        e.preventDefault()
    }

    const toggleMainGraph = ()=>{
        setShowMainGraphs(!showMainGraphs)
    }

    const getDataForDefault = (slug,asOfDate)=>{
      
        var lclDateType = !Helpers.isEmpty(slug[0]?.dateType) ? slug[0]?.dateType : "TRADEDATE";
        var asOfdate = !Helpers.isEmpty(asOfDate) ? Helpers.getDateInInputFormat(asOfDate) : Helpers.getDateInInputFormat(startDate);
        if(slug && slug.length == 1){
            setDateType(lclDateType);
        }
        var payload = {};
        payload.dateType = lclDateType;
        payload.asOfDate = asOfdate;
        payload.currencyId = selectedCurrency;

        if(slug && !Helpers.isEmpty(slug)){
            payload.portfolioIds = slug?.map((x)=>x.value).join(","); 
        }else{
            payload.portfolioIds = null;
        }
       
        getMainData(payload)
    }


    const fetchMainData = ()=>{
        console.log("in")
        var payload = {};
        payload.dateType = dateType;
        payload.asOfDate = Helpers.getDateInInputFormat(startDate);
        payload.currencyId = selectedCurrency;
        if(selectedPortfolio && !Helpers.isEmpty(selectedPortfolio)){
            payload.portfolioIds = selectedPortfolio?.map((x)=>x.value).join(","); 
        }else{
            payload.portfolioIds = null;
        }

        getMainData(payload)
    }


    const noPortfolio = ()=>{
        Helpers.pushError("Please select a portfolio!");
        return false
    }



    const getMainData = (payload)=>{
    
        setPayload(payload);
        setsLoading(true)
        Axios.get(Config.api("api/portfolio/valuation/all"),{
            params:payload
        })
        .then( (response) => {
            var data  = response.data;
            setFullData(data)
            setPercentData(data?.percentage);
            setSigmaData(data?.sigma);
            var percentColspanLcl = 2 + data?.percentage[0].values.length;
            var sigmaColspanLcl = 2 + data?.sigma[0].values.length;;
            setPercentColspan(percentColspanLcl);
            setSigmaColspan(sigmaColspanLcl);
            makeGraphData(data); 
            setsLoading(false)
        })
        .catch((err) => {
            setsLoading(false)
            Helpers.pushError(err.response.data.message)
        });
    }

    const makeGraphData = (data)=>{
        var percentData = data?.percentage;
        var lclSigmaData = data?.sigma;
        var lclAssetAllocationData  = percentData?.filter((x)=>x?.assetClass?.name?.toLowerCase() != "all").map((x)=>({name:x.assetClass.name,y:x.marketValue}));
        var lclSetCurrencyAllocationData = percentData?.filter((x)=>x?.assetClass?.name?.toLowerCase() == "all")[0]?.values;
        var lclFormatedCcyData = lclSetCurrencyAllocationData?.filter((x)=>x?.currency?.name?.toLowerCase() != "all").map((x)=>({name:x.currency.shortName,y:x.value}));
        var lclSetCurrencyAllocationData = percentData?.filter((x)=>x?.assetClass?.name.toLowerCase() == "all")[0]?.values;

        var valuationcategorieslcl = [];
        var valuationDatalcl = []

        
        lclAssetAllocationData?.forEach(list => {
            valuationcategorieslcl.push(list.name);
            valuationDatalcl.push(list.y);
        });

        setAssetAllocationData(lclAssetAllocationData);
        setCurrencyAllocationData(lclFormatedCcyData);

        setValuationData(valuationDatalcl);
        setValuationcategories(valuationcategorieslcl)
    }

    const onChangeDatetype = (e)=>{
        setDateType(e.target.value)
    }

    const onChangeCurrency = (e)=>{
        setSelectedCurrency(e.target.value);
        var index = e.nativeEvent.target.selectedIndex;
        console.log(e.nativeEvent.target[index].dataset.shortname,"e.nativeEvent.target[index].dataset.shortName")
        setSelectedCurrencylbl(e.nativeEvent.target[index].dataset.shortname)
    }


    const onClickAssetClass = (e)=>{
        var assetClassNamelcl = e.currentTarget.dataset.name;
        var assetClasslcl = e.currentTarget.dataset.type;
        setShowMainGraphs(false);
        setAssetClass(assetClasslcl);
        setAssetClasses(assetClasslcl);
        setAssetClassName(assetClassNamelcl)
    }
   


    return (
        <div className="container-fluid">
             <Loader loading={loading}/>
            <div className="dashboardFilter mt-4">
                <h5 className="heading"><i className="fa fa-pie-chart" aria-hidden="true"></i> PORTFOLIO VALUATION</h5>
                <div className="card theme-colered mt-3">
                     <div className="card-body">
                       <div className="mb-3 row b-b-1 pb-2">
                            <label className="col-sm-12 col-form-label d-flex-center"><b>Valuation of Portfolio (s):</b>
                                {
                                     portfolios && <Select  options={portfolios} 
                                                            value={selectedPortfolio}
                                                           // defaultValue={defaultPortfolio}
                                                            isMulti 
                                                            className="quarter-width" 
                                                            onChange={onChangePortfolio}
                                                            placeholder="All"
                                                            />
                                }
                            </label>
                        </div>
                        <div className="mb-3 row  pb-2 align-item-center">
                               <div className="col-sm-3">
                                    <label htmlFor="dateType" className="full-width"><b>As Of Date:</b>
                                            <select className="form-control no-border-radius" id="dateType" onChange={onChangeDatetype}>
                                                {
                                                    Config.dateTypes && Config.dateTypes.map((list,i)=>(
                                                         <option value={list.value} selected={list.value == dateType}>{list.name}</option>
                                                    ))
                                                }
                                            </select>
                                    </label>
                               </div>
                                <div className="col-sm-3">
                                    <div className="col-sm-12">
                                         <label htmlFor="dateType" className="full-width"><b>
                                             &nbsp;
                                         </b>
                                           <DatePicker
                                                closeOnScroll={true}
                                                dateFormat={Config.dateFormatInput}
                                                selected={startDate}
                                                onChange={(date) => setStartDate(date)}
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                customInput={<CustomInput/>}
                                                />
                                            </label>
                                        </div>
                                </div>
                                <div className="col-sm-3">
                                    <button className="btn btn-refresh" onClick={fetchMainData}>
                                        <i className="fa fa-refresh"></i> Refresh
                                    </button>
                                </div>
                       </div>
                       <div className="mb-3 row col-sm-3 pb-2 align-item-center">
                           <label htmlFor="currency"><b>Currency:</b>
                                <select className="form-control no-border-radius" name="currency" onChange={onChangeCurrency}>
                                                {
                                                    currencies && currencies.map((list,i)=>(
                                                         <option data-shortName={list.shortName} value={list.id} selected={selectedCurrency == list.id}>{list.name}</option>
                                                    ))
                                                }
                                </select>
                           </label>
                        </div>
                     </div>
                </div>

              
              <h5 className="heading border-0  mt-5">OVERVIEW</h5>
              <div className="card theme-colered">
                <div className="card-body">
               
                {/* <div className="card theme-colered mt-3">
                     <div className="card-body"> */}
                        <div className="mb-3 row">
                            <div className="col-md-9">
                                <div className="btn-group tab-btns" role="group" aria-label="">
                                    <button type="button" className={mode == "full" ? "btn btn-white active" : "btn btn-white"} onClick={toggleMode} data-name="full"><i data-name="full" className="material-icons">functions</i></button>
                                    <button type="button" className={mode == "percent" ? "btn btn-white active" : "btn btn-white"}  onClick={toggleMode}  data-name="percent"><i data-name="percent" className="material-icons">percent</i></button>
                                </div>
                            </div>
                            <div className="col-md-3 text-end">
                                <b>Market Value:</b> Values in {selectedCurrencylbl}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-md-12">
                                <Dtable>
                                    {mode == "percent" ?
                                        <React.Fragment>
                                             <thead>
                                                <tr>
                                                    <th>Asset Class</th>
                                                    {
                                                        percentData && percentData[0] && percentData[0]?.values &&  percentData[0]?.values?.map((th,i)=>(
                                                             <th key={i+"headerPercent"}>{th?.currency?.name}</th>
                                                        ))
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    !Helpers.isEmpty(percentData)  ?  percentData?.filter(x=>x?.assetClass?.name?.toLowerCase() != "all").map((row,i)=>(
                                                                <tr>
                                                                    <td className={assetClass == row.assetClass.value && "activeTd"}><a onClick={onClickAssetClass}  data-type={row.assetClass.value} data-name={row.assetClass.name} className={assetClass == row.assetClass.value ? "activeClass no-style pointer" : "no-style pointer"}>{row.assetClass.name}</a></td>
                                                                    {
                                                                        row?.values?.map((td,i)=>(
                                                                             <td className="text-right">{td?.value && Helpers.formatNumberComma(td?.value)+"%"}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td className="text-center">No Data Found</td>
                                                        </tr>

                                                }
                                                {
                                                   !Helpers.isEmpty(percentData) && percentData?.filter(x=>x?.assetClass?.name?.toLowerCase() == "all") && 
                                                    <React.Fragment>
                                                        <tr>
                                                            <td colSpan={percentColspan} className="emptyRow"></td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={percentColspan} className="emptyRow"></td>
                                                        </tr>
                                                    </React.Fragment>
                                                   
                                                }
                                                
                                            </tbody>
                                            <tfoot>
                                                    {
                                                        !Helpers.isEmpty(percentData) && percentData?.filter(x=>x?.assetClass?.name?.toLowerCase() == "all").map((row,i)=>(
                                                                <tr>
                                                                    <td>{row.assetClass.name}</td>
                                                                    {
                                                                        row?.values?.map((td,i)=>(
                                                                            <td className="text-right">{td?.value && Helpers.formatNumberComma(td?.value)+"%"}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                        ))

                                                        }
                                            </tfoot>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <thead>
                                                <tr>
                                                    <th>Asset Class</th>
                                                    {
                                                        sigmaData && sigmaData[0] && sigmaData[0]?.values &&  sigmaData[0]?.values?.map((th,i)=>(
                                                             <th  key={i+"headerSigma"}>{th?.currency?.name}</th>
                                                        ))
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                               {
                                                     !Helpers.isEmpty(sigmaData) ?  sigmaData?.filter(x=>x?.assetClass?.name?.toLowerCase() != "all").map((row,i)=>(
                                                                <tr>
                                                                       <td className={assetClass == row.assetClass.value && "activeTd"}>
                                                                           <a onClick={onClickAssetClass}  data-type={row.assetClass.value} data-name={row.assetClass.name} className={assetClass == row.assetClass.value ? "activeClass no-style pointer" : "no-style pointer"}>
                                                                               {row.assetClass.name}
                                                                            </a>
                                                                        </td>
                                                                    {
                                                                        row?.values?.map((td,i)=>(
                                                                             <td className="text-right">{td?.value && Helpers.amountFormat(td?.value)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                        ))
                                                        :
                                                        <tr><td className="text-center">No Data Found</td></tr>

                                                }
                                                {!Helpers.isEmpty(sigmaData) && sigmaData?.filter(x=>x?.assetClass?.name?.toLowerCase() == "all") && 
                                                   <React.Fragment>
                                                        <tr>
                                                           <td colSpan={sigmaColspan} className="emptyRow"></td>
                                                        </tr>
                                                        <tr>
                                                           <td colSpan={sigmaColspan} className="emptyRow"></td>
                                                        </tr>
                                                   </React.Fragment>}
                                            </tbody>
                                            <tfoot>
                                                    {
                                                        !Helpers.isEmpty(sigmaData) && sigmaData?.filter(x=>x?.assetClass?.name?.toLowerCase() == "all").map((row,i)=>(
                                                                <tr>
                                                                    <td>{row.assetClass.name}</td>
                                                                    {
                                                                        row?.values?.map((td,i)=>(
                                                                            <td className="text-right">{td?.value && Helpers.amountFormat(td?.value)}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                        ))
                                                    }
                                            </tfoot>
                                        </React.Fragment>

                                    }
                                    
                                </Dtable>
                            {/* </div> */}
                        {/* </div> */}
                     </div>
                </div>

                <h6 className="heading-theme  mt-5">CHARTS <a className="pointer float-end" onClick={toggleMainGraph}><i className="float-end" className={showMainGraphs ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i></a></h6>
               
                <div className={showMainGraphs ? "row" : "row hidden"}>
                    <div className="col-md-6">
                        <GraphsCard title="ASSET ALLOCATION - MARKET VALUE (%)">
                            <Pie data={assetAllocationData} />
                        </GraphsCard>
                    </div>
                    <div className="col-md-6">
                        <GraphsCard title="CURRENCY ALLOCATION - MARKET VALUE (%)">
                            <Pie data={currencyAllocationData} />
                        </GraphsCard>
                    </div>
                    <div className="col-md-6 mt-3">
                        <GraphsCard title="MARKET VALUE IN VALUATION CCY">
                            <Bar categories={valuationcategories}  data={valuationData} />
                        </GraphsCard>
                    </div>
                </div>

              
                

             </div>
             </div>

             {assetClass == "CASH" &&  <Cash payload={payload} /> }
             {assetClass == "PRIVATE" &&  <PvtInvestment payload={payload} /> }
             {
               (assetClass == "EQUITY" ||
               assetClass == "FUND" ||
               assetClass == "EL_STRUCTURED_NOTES" ||
               assetClass == "STRUCTURED_NOTES_EQUITY" ||
               assetClass == "CALL_OPTIONS" ||
               assetClass == "PUT_OPTIONS" ||
               assetClass == "COMMODITY" || 
               assetClass == "LONG_FUTURE_EQUITY" || 
               assetClass == "SHORT_FUTURE_EQUITY")
            
              &&  <Equity payload={payload} name={assetClass}/> }


             {(assetClass == "BOND" || assetClass == "STRUCTURED_NOTES_BOND") &&  <Bond payload={payload}  name={assetClass}/> }

            </div>
        </div>
    )
}

export default Index
